module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom",
      "enter-active-class": _vm.fadeIn,
      "leave-active-class": _vm.fadeOut
    }
  }, [(_vm.loading || _vm.identifierLoading) ? _c('div', {
    class: {
      loadContainer: true, inline: _vm.inline
    }
  }, [(_vm.identifier && _vm.identifierLoading) ? _c('div', {
    class: 'loader ' + _vm.classes
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    class: 'loader ' + _vm.classes
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d6ec682!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/Loader.vue
// module id = 155
// module chunks = 0